import {PRODUCTION, DEVELOPMENT} from "../constants/environment"
import env from "../env"
import type EnvVariables from "../env/interface/env"

export default function getUrlForEnv(service: string, path: string, providedEnv: EnvVariables = env) {
  const override = providedEnv.API_GW
  if (override && isPerkboxUrl(override)) {
    return `${override}${service}${path}`
  }

  const environment = providedEnv.ENVIRONMENT_NAME

  if (environment === PRODUCTION) {
    return `https://api.production.eu-west-1.perkbox.services/${service}${path}`
  } else if (environment === DEVELOPMENT) {
    return `https://api.development.eu-west-1.perkbox.services/${service}${path}`
  }
  return `https://api.staging.eu-west-1.perkbox.services/${service}${path}`
}

export const services = {
  BILLING_GATEWAY_SERVICE: "billing-gateway",
  FILE_SERVICE: "file",
  GRAPH_QL_SERVICE: "graphql",
  IDENTITY_SERVICE: "identity",
  IMAGES_SERVICE: "images",
  MEDICAL_SERVICE: "medical",
  METADATA_SERVICE: "metadata",
  ONBOARDING_SERVICE: "onboarding",
  PAYMENTS_V2_SERVICE: "payments-v2",
  PDF_SERVICE: "pdfs",
  PERMISSIONS_SERVICE: "permissions",
  PRODUCTS_SERVICE: "products",
  REWARDS_CATALOGUE_SERVICE: "rewards-catalogue",
  SELF_SIGNUP_SERVICE: "self-signup",
  SSO_SERVICE: "sso",
  STOCK_SERVICE: "stock",
  SSO_APP_SERVICE: "sso-app"
}

function isPerkboxUrl(url: string) {
  // if staging url (.net), allow any override
  if (location?.hostname.match(/\.net$/)) {
    return url
  }

  // For prod, url must start with "https" + must end with "perkbox.services"
  // All other characters must be a-z or - to stop other domain injection.
  const regex = /^https:\/\/[a-z0-9-.]*\.perkbox\.services\/$/i

  return url.match(regex)?.length === 1
}
